import axios from "axios";
import { getOrdersStart, 
	getOrdersSuccess, 
	getOrdersFailure,
	getOrderStart, 
	getOrderSuccess, 
	getOrderFailure } from "./OrderActions";
	import { apiUrl } from "../../config";

export const getOrders = async (dispatch) => {
	dispatch(getOrdersStart());

	try {
		const res = await axios.get(apiUrl + "/salesforce/" + JSON.parse(sessionStorage.getItem("user")).salesforceAccountId + "/orders",{
			headers: {
				Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user")).accessToken
			}
		});
		dispatch(getOrdersSuccess(res.data));
	} catch (error) {
		dispatch(getOrdersFailure());
	}
};

export const getOrder = async (orderId, dispatch) => {
	dispatch(getOrderStart());
	try {
		const res = await axios.get(apiUrl + "/salesforce/" + JSON.parse(sessionStorage.getItem("user")).salesforceAccountId + "/orders/" + orderId,{
			headers: {
				Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user")).accessToken
			}
		});
		dispatch(getOrderSuccess(res.data))
	} catch (error) {
		dispatch(getOrderFailure());
	}
};